import { useParams } from 'react-router-dom';

import { ContactLink } from 'components/common/contact-link/ContactLink';
import { NsCard } from 'components/common/ns-card/NsCard';
import { NsContent } from 'components/common/ns-content/NsContent';
import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';

import MpanTable from 'assets/images/mpan-table.svg';

export const testId = 'meterpointGuideTestId';

export const MeterpointGuideContent = () => {
  const { type = 'MPAN-MPRN' } = useParams();

  const electricity = type.includes('MPAN');
  const gas = type.includes('MPRN');
  const meterReferenceNumbers = type.split('-');

  return (
    <NsCard data-testid={testId}>
      <NsContent>
        <h3>Meter Reference Number</h3>
        <p>
          The meter reference number helps identify your property. We ask for it
          if we haven’t been able to find the correct gas or electricity meter
          for your address. We use this number to give you an accurate quote.
        </p>
        <p>
          It’s different from meter readings, meter serial number, and your
          account number.
        </p>
        {electricity && (
          <>
            <h3>MPAN (electricity)</h3>
            <p>
              This applies to electricity meters. It’s a 13 digit number that
              you can find on an old energy bill.{' '}
              <b>
                You only need to provide the numbers in the bottom row of the
                table.
              </b>
            </p>
            <img src={MpanTable} width={194} alt="MPAN Table" />
          </>
        )}
        {gas && (
          <>
            <h3>MPRN (gas)</h3>
            <p>
              This applies to gas meters. It’s a 4–10 digit number that you can
              find on an old energy bill.{' '}
              {electricity && (
                <>Unlike MPAN, it isn’t shown in a table, it’s just digits.</>
              )}
            </p>
          </>
        )}
        <h3>
          We can help if you can’t find your{' '}
          {meterReferenceNumbers.join(' and ')}
        </h3>

        <p>
          If you don’t have an old bill and can’t find your{' '}
          {meterReferenceNumbers.join(' or ')}, please find your meter serial
          number.
        </p>

        <p>
          Meter serial number contains both letters and numbers. It’s printed on
          the physical meter, for example Z15N190386. For newer meters, your
          meter serial number is usually found on the front of the meter, next
          to a barcode. For older meters it may be engraved on the meter.
        </p>

        <p>
          Once you have it,{' '}
          <ContactLink queryString="iclid=contact_us-meterpoint_guide">
            contact us
          </ContactLink>{' '}
          and one of our team will be able to find your{' '}
          {meterReferenceNumbers.join(' or ')} using your address and meter
          serial number and we can quote you.
        </p>
        <p>
          <NsBackCta />
        </p>
      </NsContent>
    </NsCard>
  );
};

export default MeterpointGuideContent;
